import React from "react";

const UnauthorizedAccess = () => {
  return (
    <div className="spd">
      <div className="spd_box">
        <h1>
          You're not authorized to use the Spryte Partner Platform, please
          contact your account manager for more details.
        </h1>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;

